<h1 mat-dialog-title>EDP return</h1>
<div mat-dialog-content>Are you sure you want to return EDP {{ this.data.edpName }}?</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="btnCustom btn-outline" [mat-dialog-close]="false">No</button>
  <button mat-button mat-dialog-close class="btnCustom btn-primary" [mat-dialog-close]="true">Yes</button>
</div>
